import { render, staticRenderFns } from "./SAutocomplete.vue?vue&type=template&id=32173626&scoped=true"
import script from "./sAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./sAutocomplete.ts?vue&type=script&lang=ts&external"
import style0 from "./SAutocomplete.vue?vue&type=style&index=0&id=32173626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32173626",
  null
  
)

export default component.exports